document.addEventListener('DOMContentLoaded', () => {

  const sticky = document.getElementById('sticky-atc');
  const stickyButtons = sticky.querySelectorAll('.sticky-gelander');
  const stickyCTA = document.getElementById('sticky-checkout');

  const productFormEl = document.querySelector('product-form');
  const realAddButton = productFormEl?.querySelector('[name="add"]');
  const errorWrapper = productFormEl?.querySelector('.product-form__error-message-wrapper');

  const fastingInputs = document.querySelectorAll('[data-custom-fasting] [data-fasting]');

  /* ---------- Visibility ---------- */
  const productInfoBlock = document.querySelector('.product__info-container');

  if (productInfoBlock) {
      const observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          const rect = entry.boundingClientRect;
          const isBelowProductInfoBlock = rect.bottom < 0;

          console.log(isBelowProductInfoBlock);

          sticky.classList.toggle('visible', !entry.isIntersecting && isBelowProductInfoBlock);
          sticky.setAttribute('aria-hidden', entry.isIntersecting && !isBelowProductInfoBlock);
      }, {
          root: null,
          threshold: 0.0001
      });

      observer.observe(productInfoBlock);
  }

  /* ---------- Sticky → Main ---------- */
  stickyButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const value = btn.dataset.gelander;
      const input = [...fastingInputs].find(i => i.value === value);

      if (input) input.click();
    });
  });

  /* ---------- Main → Sticky ---------- */
  fastingInputs.forEach(input => {
    input.addEventListener('change', () => {
      if (!input.checked) return;

      stickyButtons.forEach(btn => {
        const active = btn.dataset.gelander === input.value;
        btn.classList.toggle('active', active);
        btn.setAttribute('aria-pressed', active);
      });

      syncCTAState();
    });
  });

  /* ---------- CTA state sync ---------- */
  const syncCTAState = () => {
    const disabled = realAddButton?.hasAttribute('disabled');
    stickyCTA.disabled = disabled;
  };

  // початковий стан
  syncCTAState();

  // коли VariantSelects міняє кнопку
  document.addEventListener('diameterChanged', syncCTAState);
  document.addEventListener('change', syncCTAState);

  /* ---------- CTA click ---------- */
  stickyCTA.addEventListener('click', () => {
    if (stickyCTA.disabled) {
      errorWrapper?.removeAttribute('hidden');
      return;
    }

    realAddButton?.click();
  });

});